import _ from 'lodash';
import { fabric } from 'fabric';
import { getState } from '~src/state';
import { addObjRefId, triggerStateChangedRequest } from '~core';
import editorConfig from '~config/editorConfig';
import { loadSvgAsync, setProfilePhotoToAllMagicFrames } from '~src/utils';

const buildFallbackClip = (object) =>
  new fabric.Rect({
    left: 0,
    top: 0,
    width: object.width,
    height: object.height,
    fill: 'transparent',
  });

export const addMagicFrameToCanvas = (options) => {
  if (!options.frameUrl) {
    throw new Error(
      'Missing frame in options.frameUrl (addMagicFrameToCanvas)'
    );
  }

  let gender = 'm';
  const servizio = getState('selected.servizio');
  if (servizio) {
    gender = _.get(servizio, 'sesso', 'm');
  }

  return new Promise((resolve) => {
    const magicFrame = new fabric.MagicFrame(
      editorConfig.magicFrameBgPlaceholder,
      editorConfig.magicFramePersonPlaceholders[gender],
      options.frameUrl,
      {
        width: options.width,
        height: options.height,
        left: window.canvas.width / 2,
        top: window.canvas.height / 2,
        scaleX: 1,
        scaleY: 1,
      }
    );

    window.canvas.add(magicFrame);

    magicFrame.on('frame:init', async function (object) {
      if (options.svgClip) {
        try {
          const { objects } = await loadSvgAsync(options.svgClip);
          const firstPath = objects && objects[0];
          object.clipping = firstPath || buildFallbackClip(object);
        } catch (error) {
          console.error('[magic-frame] impossibile caricare il clip SVG', {
            svgClip: options.svgClip,
            error,
          });
          object.clipping = buildFallbackClip(object);
        }
        object.scalePersonToCover();
      } else {
        object.clipping = buildFallbackClip(object);
      }

      addObjRefId(object);
      window.canvas.renderAll();
      await setProfilePhotoToAllMagicFrames();
      // La entry di undo/redo si crea solo ora che clip e foto sono pronti:
      // lo snapshot a object:added serializzerebbe una cornice a metà.
      triggerStateChangedRequest();
      resolve();
    });
  });
};
